/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Pricing_League_SummaryInputs */

const ja_playdata_pricing_league_summary = /** @type {(inputs: Playdata_Pricing_League_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開催日程が10日間以上のeスポーツ大会`)
};

const en_playdata_pricing_league_summary = /** @type {(inputs: Playdata_Pricing_League_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For medium to large esports events broadcasting for 10 or more days.`)
};

/**
* | output |
* | --- |
* | "For medium to large esports events broadcasting for 10 or more days." |
*
* @param {Playdata_Pricing_League_SummaryInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_pricing_league_summary = /** @type {((inputs?: Playdata_Pricing_League_SummaryInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Pricing_League_SummaryInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_pricing_league_summary(inputs)
	return en_playdata_pricing_league_summary(inputs)
});